"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "filterPipelineDefinitions", {
    enumerable: true,
    get: function() {
        return filterPipelineDefinitions;
    }
});
function filterPipelineDefinitions(targets, pipeline) {
    const tasksSet = new Set();
    for (const target of targets){
        tasksSet.add(target.task);
    }
    const filteredPipeline = {};
    for (const [id, definition] of Object.entries(pipeline ?? {})){
        if (tasksSet.has(id)) {
            filteredPipeline[id] = definition;
        }
    }
    return filteredPipeline;
}
